import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useImporter } from './contexts/ImporterContext'
import { useLocation, useNavigate } from 'react-router-dom'

const LoginHandler = ({ children }) => {
  const { isRegistered, isLoading, importerLoadError } = useImporter()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const hasShownAlertRef = useRef(false)

  const registerPath = '/app/register'
  const errorPath = '/app/500'

  useEffect(() => {
    if (isLoading) {
      return
    }

    if (importerLoadError && pathname !== errorPath) {
      navigate(errorPath, { replace: true })
      return
    }

    if (isRegistered === false && pathname !== registerPath && pathname !== errorPath) {
      if (!hasShownAlertRef.current) {
        hasShownAlertRef.current = true
      }

      navigate(registerPath, { replace: true })
    }
  }, [isRegistered, isLoading, importerLoadError, pathname, navigate])

  if (isLoading) {
    return null
  }

  if (importerLoadError && pathname !== errorPath) {
    return null
  }

  if (isRegistered === false && pathname !== registerPath && pathname !== errorPath) {
    return null
  }

  return children
}

LoginHandler.propTypes = {
  children: PropTypes.node,
}

export default LoginHandler
